<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>学生回访</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
      >
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="姓名/微信/大学/专业" clearable @keyup.enter.native="selList()"></el-input>
        </el-form-item>
        <el-form-item
          label="学校"
          label-width="80px"
          style="margin-left: -15px"
        >
          <el-select v-model="query.schid" filterable clearable @change="selList()">
            <el-option label="请选择" value></el-option>
            <el-option
              v-for="item in schoollist"
              :label="item.label"
              :value="item.value"
              :key="item.value"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <SelectAbroad v-on:selabroad="function (str) {query.abroadTime = str;selList();}"></SelectAbroad>
        <el-form-item label="缴费时间" label-width="80px">
          <el-date-picker
            v-model="payRange"
            clearable
            @change="onPayRangeChange"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始"
            end-placeholder="结束"
            style="width:240px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="学历" label-width="50px">
          <el-select v-model="query.eduBack" placeholder="请选择" clearable filterable style="width:120px">
            <el-option v-for="item in eduList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="进路" label-width="50px">
          <el-select v-model="query.pathDirection" placeholder="请选择" clearable filterable style="width:130px" @change="selList()">
            <el-option v-for="item in pathDirectionList" :key="item" :label="pathDirectionLabel(item)" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文理" label-width="50px">
          <el-select v-model="query.artsScience" placeholder="请选择" clearable filterable style="width:100px">
            <el-option v-for="item in artsScienceFilterList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合格时间" label-width="70px">
          <el-date-picker v-model="query.eligibilityTime" type="month" value-format="yyyy-MM" format="yyyy-MM" placeholder="月份" style="width:130px" clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="入学时间" label-width="70px">
          <el-date-picker v-model="query.incomeDate" type="month" value-format="yyyy-MM" format="yyyy-MM" placeholder="月份" style="width:130px" clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="日语" label-width="50px">
          <el-select v-model="query.japaneseScore" placeholder="请选择" clearable filterable style="width:100px">
            <el-option v-for="item in japlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="案例" label-width="50px">
          <el-select v-model="query.caseModule" placeholder="请选择" clearable style="width:120px" @change="selList()">
            <el-option label="申请案例" value="apply"></el-option>
            <el-option label="文案案例" value="copy"></el-option>
            <el-option label="课程签约" value="course"></el-option>
            <el-option label="日语学习" value="jap"></el-option>
            <el-option label="私塾学习" value="private"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="英语" label-width="50px">
          <el-select v-model="query.englishType" placeholder="请选择" clearable filterable style="width:100px">
            <el-option v-for="item in enlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目" label-width="50px">
          <el-select v-model="query.project" placeholder="请选择" clearable style="width:100px">
            <el-option label="日语" value="日语"></el-option>
            <el-option label="鸣野" value="鸣野"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button v-if="userIsAdmain" type="success" @click="exportClick()">导出</el-button>
          <el-button type="warning" @click="importPathClick()">导入进路</el-button>
          <div id="pathImportUpload" style="display:none"></div>
        </el-form-item>
      </el-form>

      <el-dialog title="导入结果" :visible.sync="pathImportDialogVisible" width="560px" top="12vh">
        <div class="path-import-result">
          <p class="path-import-summary" :class="{ 'is-error': pathImportResult.isError }">{{ pathImportResult.summary }}</p>
          <div v-if="pathImportResult.duplicateNames.length" class="path-import-block">
            <div class="path-import-label">重名学生（已跳过，请手动处理）</div>
            <div class="path-import-text">{{ pathImportResult.duplicateNames.join("、") }}</div>
          </div>
          <div v-if="pathImportResult.notFoundNames.length" class="path-import-block">
            <div class="path-import-label">未匹配姓名</div>
            <div class="path-import-text">{{ pathImportResult.notFoundNames.join("、") }}</div>
          </div>
          <div v-if="pathImportResult.errors.length" class="path-import-block">
            <div class="path-import-label">明细（{{ pathImportResult.errors.length }} 条）</div>
            <ul class="path-import-errors">
              <li v-for="(item, idx) in pathImportResult.errors" :key="'path-err-' + idx">{{ item }}</li>
            </ul>
          </div>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="pathImportDialogVisible = false">确定</el-button>
        </span>
      </el-dialog>

      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>学生回访列表</span>
        </div>
        <el-tabs v-model="state" @tab-click="stateClick">
          <el-tab-pane label="全部" name=""></el-tab-pane>
          <el-tab-pane label=" 待处理 " name="2"></el-tab-pane>
          <el-tab-pane label=" 已处理 " name="3"></el-tab-pane>
        </el-tabs>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          :span-method="pathSpanMethod"
          style="width: 100%"
        >
          <el-table-column label="状态" prop="_mergeBase">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.state == 3">{{
                scope.row.stateName
              }}</el-tag>
              <el-tag type="danger" v-else>{{
                scope.row.state == 1 ? "待处理" : scope.row.stateName
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="stuName" label="姓名" width="90"></el-table-column>
          <el-table-column prop="wechat" label="微信" width="110" show-overflow-tooltip></el-table-column>
          <el-table-column prop="age" label="年龄" width="60"></el-table-column>
          <el-table-column prop="eduBack" label="学历" width="80"></el-table-column>
          <el-table-column prop="zzAreaShow" label="住址" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="japanese" label="日语" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="english" label="英语" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="abroadDate" label="留学时间" width="90"></el-table-column>
          <el-table-column prop="applySchool" label="申请学校" min-width="120" show-overflow-tooltip></el-table-column>
          <!-- 进路字段：按筛选进路切换列；未筛显示全部（顺序见需求） -->
          <el-table-column label="进路" width="130">
            <template slot-scope="scope">
              <template v-if="scope.row.pathOrder">
                <el-tag size="mini" type="info">进路{{ scope.row.pathOrder }}</el-tag>
                <span style="margin-left:6px">{{ pathDirectionLabel(scope.row.pathDirection, scope.row.eduBack) }}</span>
              </template>
              <span v-else>{{ pathDirectionLabel(scope.row.pathDirection, scope.row.eduBack) }}</span>
            </template>
          </el-table-column>
          <!-- 升学列：院校→专业→文理→日语→英语→EJU→校内考→考学经验→合格→入学→入学方式 -->
          <el-table-column v-if="showStudyCols" label="院校/大学院" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColSchool(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showStudyCols" label="专业/研究科" width="110" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColMajor(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showStudyCols" prop="artsScience" label="文理" width="70"></el-table-column>
          <el-table-column v-if="showStudyCols || showJobCols" label="日语成绩" width="90" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColJapanese(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showStudyCols || showJobCols" label="英语成绩" width="100" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColEnglish(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showStudyCols" label="EJU分数" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColEju(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showStudyCols" label="校内考" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColInternalExam(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showStudyCols" label="考学经验" min-width="110" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColExamExperience(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showStudyCols" label="合格时间" width="90">
            <template slot-scope="scope">{{ visitColEligibilityTime(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showStudyCols" label="入学时间" width="90">
            <template slot-scope="scope">{{ visitColIncomeDate(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showStudyCols" label="入学方式" width="100" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColEnrollMethod(scope.row) }}</template>
          </el-table-column>
          <!-- 就职列：企业→类型→行业→规模→岗位→年薪→历程→经验→入职 -->
          <el-table-column v-if="showJobCols" label="就职企业" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColCompanyName(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showJobCols" label="企业类型" width="90" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColCompanyType(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showJobCols" label="行业" width="90" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColIndustry(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showJobCols" label="企业规模" width="90" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColCompanyScale(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showJobCols" label="岗位" width="90" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColPosition(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showJobCols" label="大概年薪" width="90" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColAnnualSalary(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showJobCols" label="就职历程" width="110" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColJobPath(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showJobCols" label="就职经验" min-width="110" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColJobExperience(scope.row) }}</template>
          </el-table-column>
          <el-table-column v-if="showJobCols" label="入职时间" width="90">
            <template slot-scope="scope">{{ visitColJobStartOnly(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="其他/说明" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">{{ visitColOther(scope.row) }}</template>
          </el-table-column>

          <el-table-column label="跟进状态" prop="_mergeFollow" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <el-table-column prop="adviserName" label="顾问" width="90" show-overflow-tooltip></el-table-column>
          <el-table-column prop="documentName" label="文案" width="90" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" prop="_mergeAction" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑进路" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="填案例" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-document"
                    @click="caseClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="基本信息" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="viewClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  content="查看聊天截图"
                  placement="top"
                  v-if="scope.row.imgList"
                >
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-picture"
                    @click="imgClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <student-path-dialog
      :visible.sync="pathDialogVisible"
      :stuID="pathStuID"
      :visitID="pathVisitID"
      :visit-subject="pathVisitSubject"
      :visit-notice-date="pathVisitNoticeDate"
      @saved="getList"
    />
    <student-case-dialog :visible.sync="caseDialogVisible" :stuID="caseStuID" @saved="getList"></student-case-dialog>
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />

    <el-dialog title="聊天截图列表" :visible.sync="imgDialogVisible">
      <el-row :gutter="20">
        <el-col :span="5" v-for="(item, index) in imgList" :key="index">
          <a :href="domain + item" target="_blank">
            <el-card style="margin-top: 10px; text-align: center">
              <img
                :src="domain + item"
                class="image"
                style="max-height: 100px"
              />
              <div style="padding: 8px 0px 0px 0px">
                <div class="bottom clearfix">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                    style="margin-left: 0px"
                  ></el-button>
                </div>
              </div>
            </el-card>
          </a>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="基本信息" :visible.sync="viewDialog">
      <table
        class="myTable el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="width: 100%; line-height: 2em"
      >
        <tr>
          <td>姓名：{{ info.realName }}</td>
          <td>性别：{{ info.sex ? "男" : "女" }}</td>
        </tr>
        <tr>
          <td>留学时间：{{ info.abroadDate }}</td>
          <td>来源：{{ info.origin }} {{ info.recName }}</td>
        </tr>
        <tr>
          <td>微信：{{ info.wechat }}</td>
          <td>QQ：{{ info.qq }}</td>
        </tr>
        <tr>
          <td>电话：{{ info.mobile }}</td>
          <td>地区：{{ info.zzProvinceName + info.zzCityName }}</td>
        </tr>
        <tr>
          <td>学历：{{ info.eduBack }}</td>
          <td></td>
        </tr>
        <tr>
          <td>日语：{{ info.japanese }}</td>
          <td>英语：{{ info.english }}</td>
        </tr>
      </table>

      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="viewDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import caseOptions from "@/plugins/caseOptions.js";
import {
  visitColEligibilityTime,
  visitColJobStartOnly,
  visitColIncomeDate,
  visitColSchool,
  visitColCompanyName,
  visitColMajor,
  visitColEju,
  visitColEnrollMethod,
  visitColInternalExam,
  visitColJapanese,
  visitColEnglish,
  visitColExamExperience,
  visitColCompanyType,
  visitColCompanyScale,
  visitColIndustry,
  visitColPosition,
  visitColAnnualSalary,
  visitColJobPath,
  visitColJobExperience,
  visitColOther,
  resolveVisitPathColMode
} from "@/plugins/caseVisitListHelper.js";
import SelectAbroad from "@/components/SelectAbroad";
import StudentCaseDialog from "@/components/StudentCaseDialog";
import StudentPathDialog from "@/components/StudentPathDialog";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
export default {
  data() {
    return {
      domain: url.getDomain(),
      userIsAdmain: user.isAdmin(),
      key: "",
      payRange: [],
      query: {},
      caseDialogVisible: false,
      caseStuID: 0,
      pathDialogVisible: false,
      pathStuID: 0,
      pathVisitID: 0,
      pathVisitSubject: "",
      pathVisitNoticeDate: "",
      eduList: caseOptions.eduList,
      pathDirectionList: caseOptions.pathDirectionList,
      artsScienceFilterList: caseOptions.artsScienceFilterList,
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      imgDialogVisible: false,
      state: "",
      stuid: 0,
      japlist: url.getJapLevelListForStu(),
      enlist: caseOptions.englishTypeList.map(function(x) { return { id: x, name: x }; }),
      imgList: [],
      schoollist: [],
      viewDialog: false,
      info: {},
      pathImportDialogVisible: false,
      pathImportResult: {
        summary: "",
        duplicateNames: [],
        notFoundNames: [],
        errors: [],
        isError: false
      },
      pathImporting: false,
      followDialogVisible: false,
      followType: "",
      followDialogRow: null,
    };
  },
  computed: {
    /**
     * 列表列切换：
     * 1) 筛「进路=就职」→ 只就职列；筛其它进路 → 只升学列
     * 2) 未筛时看当前页：全是就职 / 全是升学 → 对应该列；有就职也有升学 → 全部列
     */
    pathColMode() {
      var dir = this.query && this.query.pathDirection;
      return resolveVisitPathColMode(dir, this.tableData);
    },
    showStudyCols() {
      return this.pathColMode === "study" || this.pathColMode === "all";
    },
    showJobCols() {
      return this.pathColMode === "job" || this.pathColMode === "all";
    }
  },
  components: {
    SelectAbroad,
    StudentCaseDialog,
    StudentPathDialog,
    OtherDeptFollow,
    FollowDetailDialog,
  },
  methods: {
    visitColEligibilityTime,
    visitColJobStartOnly,
    visitColIncomeDate,
    visitColSchool,
    visitColCompanyName,
    visitColMajor,
    visitColEju,
    visitColEnrollMethod,
    visitColInternalExam,
    visitColJapanese,
    visitColEnglish,
    visitColExamExperience,
    visitColCompanyType,
    visitColCompanyScale,
    visitColIndustry,
    visitColPosition,
    visitColAnnualSalary,
    visitColJobPath,
    visitColJobExperience,
    visitColOther,
    pathDirectionLabel(dir, eduBack) {
      if (!dir) return "";
      if (caseOptions.pathDirectionDisplay) {
        return caseOptions.pathDirectionDisplay(dir, eduBack);
      }
      return (caseOptions.pathDirectionLabel && caseOptions.pathDirectionLabel[dir]) || dir;
    },
    /** 同一回访多进路：基础信息列合并 */
    applyPathRowSpans(rows) {
      if (!rows || !rows.length) return rows || [];
      var i = 0;
      while (i < rows.length) {
        var j = i + 1;
        while (j < rows.length && rows[j].id === rows[i].id && rows[j].stuID === rows[i].stuID) {
          j++;
        }
        var span = j - i;
        for (var k = i; k < j; k++) {
          rows[k]._baseSpan = k === i ? span : 0;
        }
        i = j;
      }
      return rows;
    },
    pathSpanMethod({ row, column }) {
      var mergeProps = {
        _mergeBase: true,
        stuName: true,
        wechat: true,
        age: true,
        zzAreaShow: true,
        japanese: true,
        english: true,
        abroadDate: true,
        applySchool: true,
        _mergeFollow: true,
        adviserName: true,
        documentName: true,
        _mergeAction: true
      };
      if (!mergeProps[column.property]) {
        return [1, 1];
      }
      var span = row._baseSpan;
      if (span === 0) return [0, 0];
      return [span, 1];
    },
    caseClick(row) {
      this.caseStuID = row.stuID;
      this.caseDialogVisible = true;
    },
    exportClick() {
      if (!user.isAdmin()) {
        this.$message.error("仅超级管理员可导出");
        return;
      }
      var params = Object.assign({}, this.query);
      params.key = this.key;
      params.state = this.state == 0 ? "" : this.state;
      params.exportName = "学生回访案例";
      if (this.payRange && this.payRange.length === 2) {
        params.payStart = this.payRange[0];
        params.payEnd = this.payRange[1];
      }
      var result = [];
      for (var k in params) {
        if (params[k] !== undefined && params[k] !== null && params[k] !== "") {
          result.push(k + "=" + encodeURIComponent(params[k]));
        }
      }
      window.open(url.getStu("exportvisit") + "?" + result.join("&"));
    },
    onPayRangeChange() {
      if (this.payRange && this.payRange.length === 2) {
        this.query.payStart = this.payRange[0];
        this.query.payEnd = this.payRange[1];
      } else {
        this.query.payStart = "";
        this.query.payEnd = "";
      }
      this.selList();
    },
    importPathClick() {
      var _this = this;
      this.$confirm(
        "请使用标准 Excel 模板填写后导入。系统按【姓名】精确匹配学生；若存在重名学生将跳过该行，需您手动在「编辑进路」中修改。",
        "导入进路",
        { confirmButtonText: "选择文件", cancelButtonText: "取消", type: "warning" }
      ).then(function() {
        _this.initPathImportUploader();
        $("#pathImportUpload input[type=file]").val("").click();
      }).catch(function() {});
    },
    initPathImportUploader() {
      if ($("#pathImportUpload input[type=file]").length > 0) return;
      var _this = this;
      $("#pathImportUpload").uploader({
        url: url.getUpload(),
        fileExts: "xlsx;xls",
        text: "导入进路",
        more: false,
        auto: true,
        isImg: false,
        handleType: "0",
        onSuccess: function(data) {
          var filePath = (data && data.relativeName) || "";
          if (!filePath) {
            _this.showPathImportDialog({
              summary: "上传失败，未返回文件地址",
              duplicateNames: [],
              notFoundNames: [],
              errors: [],
              isError: true
            });
            return;
          }
          _this.doImportCasePath(filePath);
        },
        onError: function(msg) {
          _this.showPathImportDialog({
            summary: msg || "上传失败",
            duplicateNames: [],
            notFoundNames: [],
            errors: [],
            isError: true
          });
        }
      });
    },
    doImportCasePath(filePath) {
      var _this = this;
      _this.pathImporting = true;
      var loading = _this.$loading({ lock: true, text: "正在导入，请稍候…" });
      $.post(url.getStu("importcasepath"), { filePath: filePath }, function(res) {
        _this.pathImporting = false;
        loading.close();
        if (!res || res.status == 0 || res.status === false) {
          _this.showPathImportDialog({
            summary: (res && (res.msg || res.innerMsg)) || "导入失败",
            duplicateNames: [],
            notFoundNames: [],
            errors: [],
            isError: true
          });
          return;
        }
        var data = (res && res.data) || {};
        _this.showPathImportDialog({
          summary: res.msg || "导入完成",
          duplicateNames: data.duplicateNames || [],
          notFoundNames: data.notFoundNames || [],
          errors: data.errors || [],
          isError: !!(data.duplicateNames && data.duplicateNames.length) ||
            !!(data.notFoundNames && data.notFoundNames.length) ||
            !!(data.errors && data.errors.length)
        });
        _this.selList();
      }).fail(function(xhr) {
        _this.pathImporting = false;
        loading.close();
        var msg = "导入失败";
        if (xhr.responseJSON) {
          msg = xhr.responseJSON.msg || xhr.responseJSON.innerMsg || msg;
        } else if (xhr.responseText) {
          try {
            var j = JSON.parse(xhr.responseText);
            msg = j.msg || j.innerMsg || msg;
          } catch (e) {
            msg = "导入失败（HTTP " + xhr.status + "）";
          }
        } else {
          msg = "导入失败（HTTP " + xhr.status + "）";
        }
        _this.showPathImportDialog({
          summary: msg,
          duplicateNames: [],
          notFoundNames: [],
          errors: [],
          isError: true
        });
      });
    },
    showPathImportDialog(result) {
      this.pathImportResult = result;
      this.pathImportDialogVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.query.isEnable = val;
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.query.sort = sortColumn.prop;
      this.query.order = sortColumn.order;
      this.getList();
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;
      params.state = _this.state == 0 ? "" : _this.state;
      var link = url.getStu("getlist_visit");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = _this.applyPathRowSpans(data.list || []);
        _this.total = data.total;
      });
    },
    //按状态查询
    stateClick: function (tab, event) {
      this.getList();
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    school: function () {
      var _this = this;
      var link = url.getCommon("getschool");
      $.get(link, {}, (data) => {
        _this.schoollist = data;
      });
    },
    viewClick(row) {
      var _this = this;
      var id = row.stuID;
      this.viewDialog = true;
      var link = url.getStu("getvisit_stu");
      $.get(link, { stuid: id }, (data) => {
        _this.info = data;
      });
    },
    imgClick(row) {
      var _this = this;
      if (row.imgList) {
        _this.imgList = row.imgList.split(",");
        _this.imgDialogVisible = true;
      }
    },
    editClick(row) {
      this.pathStuID = row.stuID;
      this.pathVisitID = row.id;
      this.pathVisitSubject = row.subject || "";
      this.pathVisitNoticeDate = row.noticeDate || "";
      this.pathDialogVisible = true;
    },
    showFollowDialog(type, row) {
      this.followType = type;
      this.followDialogRow = row
        ? Object.assign({}, row, {
            id: row.stuID || row.id,
            realName: row.stuName || row.realName
          })
        : {};
      this.followDialogVisible = true;
    },
    goTo(id) {
      this.$router.push({
        name: "follow",
        query: { id: id },
      });
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getStu("delete_base"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { idList: id }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  mounted() {
    this.getList();
    this.school();
  },
};
</script>

<style  scoped>
.path-import-summary {
  margin: 0 0 12px;
  font-size: 15px;
  color: #67c23a;
}
.path-import-summary.is-error {
  color: #f56c6c;
}
.path-import-block + .path-import-block {
  margin-top: 12px;
}
.path-import-label {
  font-weight: 600;
  color: #606266;
  margin-bottom: 6px;
}
.path-import-text {
  color: #303133;
  line-height: 1.6;
  word-break: break-all;
}
.path-import-errors {
  margin: 0;
  padding-left: 18px;
  max-height: 220px;
  overflow-y: auto;
  color: #606266;
  line-height: 1.6;
}
.myTable td {
  text-indent: 10px;
}
</style>
